import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const InputStyledSection = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 12px;

    &:not(:last-child) {
        border-bottom: 1px solid ${owcTheme['one-color-background-intensity-low']};
    }

    &.column {
        flex-direction: column;
        gap: 16px;
    }

    > div {
        display: flex;
        flex-direction: column;

        .description {
            padding-right: 48px;
            padding-bottom: 16px;
            color: #706b69;
        }
    }

    &.row > div {
        min-height: 40px;
        justify-content: center;
    }

    owc-typography {
        color: var(--one-color-gray-600);
    }

    .description-icon {
        color: var(--one-color-gray-600) !important;
    }

    > *:last-child {
        width: 240px;
        min-width: 240px;
    }
`;

export const InputSectionTitle = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`;
